import { FloatingOverlay } from '@floating-ui/react';
import Icon from '@ui/components/atoms/icon/icon.atom';
import { clsxm } from '@ui/utils/style.util';
import { ComponentProps, ComponentPropsWithoutRef, memo } from 'react';

// #region Types
export type LoadingIndicatorProps = ComponentPropsWithoutRef<'div'> & {
  backdropProps?: ComponentProps<typeof FloatingOverlay>;
  open?: boolean;
};
// #endregion

// #region Styles
const BACKDROP_STYLES = {
  false: 'pointer-events-none bg-overlay/0',
  true: 'pointer-events-auto bg-overlay/50',
};

const MODAL_STYLES = {
  false: 'scale-0 opacity-0',
  true: 'scale-100 opacity-100',
};
// #endregion

function BaseLoadingIndicator({
  backdropProps,
  className,
  open = false,
  ...rest
}: LoadingIndicatorProps) {
  return (
    <FloatingOverlay
      {...backdropProps}
      className={clsxm(
        'flex items-center justify-center z-backdrop duration-200',
        BACKDROP_STYLES[`${open}`],
        backdropProps?.className,
      )}
    >
      <div
        {...rest}
        className={clsxm(
          'bg-white-snow py-8 px-16 z-dialog duration-200 text-orange-dark',
          MODAL_STYLES[`${open}`],
          className,
        )}
        role="progressbar"
      >
        <Icon.Loading className="animate-spin" height={92} width={92} />
      </div>
    </FloatingOverlay>
  );
}
BaseLoadingIndicator.displayName = 'LoadingIndicator';

const LoadingIndicator = memo(BaseLoadingIndicator);

export default LoadingIndicator;
